"use client"

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import ThemeProvider from "react-bootstrap/esm/ThemeProvider";
import UserProvider from "./components/auth/auth";
import { DatabaseProvider } from "./storage/db.";
import { WebsocketProvider } from "./websocket/websocket";
import { DispatcherProvider } from "./eventsDispatcher";
import { DataProvider } from "./storage/accessors";
import { TaskModalProvider } from "./components/TaskModalContext";
import { ScreenSizeProvider } from "./contexts/screenSizeContext";
import { useLocation } from 'react-router';
import { ProfileModalProvider } from "./contexts/profileModalContext";
import { AppThemeProvider, useTheme } from "./contexts/themeContext";
import AppUpdater from "./components/appUpdater";

// Добавляем иконки в библиотеку Font Awesome
library.add(fas, fab);

interface ClientProvidersProps {
    children: React.ReactNode;
}

const ClientContent: React.FC<ClientProvidersProps> = ({ children }) => {
    return (
        <ThemeProvider
            breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
            minBreakpoint="xxs"
        >
            {children}
            <AppUpdater />
        </ThemeProvider>
    );
};

export const ClientProviders: React.FC<ClientProvidersProps> = ({ children }) => {
    const location = useLocation();
    const wheelId = location.pathname.split('/')[1];

    return (
        <AppThemeProvider>
            <UserProvider>
                {wheelId && wheelId !== '*' &&
                    <DatabaseProvider>
                        <WebsocketProvider>
                            <DispatcherProvider>
                                <DataProvider>
                                    <ScreenSizeProvider>
                                        <TaskModalProvider>
                                            <ProfileModalProvider>
                                                <ClientContent>{children}</ClientContent>
                                            </ProfileModalProvider>
                                        </TaskModalProvider>
                                    </ScreenSizeProvider>
                                </DataProvider>
                            </DispatcherProvider>
                        </WebsocketProvider>
                    </DatabaseProvider>
                }
                {!wheelId &&
                    <ScreenSizeProvider>
                        <ClientContent>{children}</ClientContent>
                    </ScreenSizeProvider>
                }
            </UserProvider>
        </AppThemeProvider>
    );
};